import { lazy, FC, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
const SettingPage = lazy(() => import("../modules/menu_setting/SettingPage"));
const EmployeePage = lazy(() => import("../modules/Employee/employeePage"));
const CustomerPage = lazy(() => import("../modules/Customer/customerPage"));
const BusinessPage = lazy(() => import("../modules/Business/businessPage"));
const MenuPage = lazy(() => import("../modules/Menu/menuPage"));
const PackagePage = lazy(() => import("../modules/Package/packagePage"));
const CategoryPage = lazy(() => import("../modules/Category/categoryPage"));
const IngredientPage = lazy(() => import("../modules/Ingredient/ingredientPage"));
const BomPage = lazy(() => import("../modules/Bom/bomPage"));
const VendorPage = lazy(() => import("../modules/Vendor/vendorPage"));
const OrderPage = lazy(() => import("../modules/Order/orderPage"));
const StockPage = lazy(() => import("../modules/Stock/stockPage"));
const CookingOrderPage = lazy(() => import("../modules/CookingOrder/cookingOrderPage"));
const PurchaseOrderPage = lazy(() => import("../modules/PurchaseOrder/purchaseOrderPage"));
const VendorCreditNotePage = lazy(() => import("../modules/VendorCreditNote/vendorCreditNotePage"));
const CostLedgerPage = lazy(() => import("../modules/CostLedger/costLedgerPage"));
const PayrollPage = lazy(() => import("../modules/Payroll/payrollPage"));
const StockTransferPage = lazy(() => import("../modules/StockTransfer/stockTransferPage"));
const StockCountPage = lazy(() => import("../modules/StockCount/stockCountPage"));
const ReportPage = lazy(() => import("../modules/Report/ReportPage"));
const DashboardPage = lazy(() => import("../modules/Dashboard/DashboardPage"));
const TransportPage = lazy(() => import("../modules/Transport/transportPage"));

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route
          path="main"
          element={
            <SuspensedView>
              <div></div>
            </SuspensedView>
          }
        />

        <Route path="main" element={<div></div>} />
        <Route path="setting/*" element={
          <SuspensedView>
            <SettingPage />
          </SuspensedView>
        } />
        <Route path="employee/*" element={
          <SuspensedView>
            <EmployeePage />
          </SuspensedView>
        } />
        <Route path="customer/*" element={
          <SuspensedView>
            <CustomerPage />
          </SuspensedView>
        } />
        <Route path="business/*" element={
          <SuspensedView>
            <BusinessPage />
          </SuspensedView>
        } />
        <Route path="menu/*" element={
          <SuspensedView>
            <MenuPage />
          </SuspensedView>
        } />
        <Route path="package/*" element={
          <SuspensedView>
            <PackagePage />
          </SuspensedView>
        } />
        <Route path="category/*" element={
          <SuspensedView>
            <CategoryPage />
          </SuspensedView>
        } />
        <Route path="ingredient/*" element={
          <SuspensedView>
            <IngredientPage />
          </SuspensedView>
        } />
        <Route path="bom/*" element={
          <SuspensedView>
            <BomPage />
          </SuspensedView>
        } />
        <Route path="vendor/*" element={
          <SuspensedView>
            <VendorPage />
          </SuspensedView>
        } />
        <Route path="order/*" element={
          <SuspensedView>
            <OrderPage />
          </SuspensedView>
        } />
        <Route path="stock/*" element={
          <SuspensedView>
            <StockPage />
          </SuspensedView>
        } />
        <Route path="cooking_order/*" element={
          <SuspensedView>
            <CookingOrderPage />
          </SuspensedView>
        } />
        <Route path="purchase_order/*" element={
          <SuspensedView>
            <PurchaseOrderPage />
          </SuspensedView>
        } />
        <Route path="vendor_credit_note/*" element={
          <SuspensedView>
            <VendorCreditNotePage />
          </SuspensedView>
        } />
        <Route path="cost_ledger/*" element={
          <SuspensedView>
            <CostLedgerPage />
          </SuspensedView>
        } />
        <Route path="payroll/*" element={
          <SuspensedView>
            <PayrollPage />
          </SuspensedView>
        } />
        <Route path="stock_transfer/*" element={
          <SuspensedView>
            <StockTransferPage />
          </SuspensedView>
        } />
        <Route path="stock_count/*" element={
          <SuspensedView>
            <StockCountPage />
          </SuspensedView>
        } />
        <Route path="report/*" element={
          <SuspensedView>
            <ReportPage />
          </SuspensedView>
        } />
        <Route path="dashboard/*" element={
          <SuspensedView>
            <DashboardPage />
          </SuspensedView>
        } />
        <Route path="transport/*" element={
          <SuspensedView>
            <TransportPage />
          </SuspensedView>
        } />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");

  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });

  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
